import type { FC } from 'react';
import type { ICarrierLogoProps } from '../../ShipmentLogo';
import { CarrierLogoImage } from './CarrierLogo.styles';

export const CarrierLogo: FC<Omit<ICarrierLogoProps, 'variant'>> = ({ carrierLogo, carrierName }) => {
  const imageSource = carrierLogo ?? '/images/default-carrier-logo.svg';

  return <CarrierLogoImage src={imageSource} alt={carrierName ?? 'Carrier Logo'} />;
};
